<template>
  <b-sidebar
    id="add-new-group-sidebar"
    :visible="isAddNewGroupSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetData"
    @change="(val) => $emit('update:is-add-new-group-sidebar-active', val)"
  >

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Create New Group')}}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>

      <!-- BODY -->
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="onSubmit">

          <!-- Name -->
            <b-form-group :label="$t('Name')" label-for="name">
              <b-form-input
                id="name"
                v-model="groupData.name"
                autofocus
                :state="errors && ('name' in errors) ? false : null"
                trim
                autocomplete="off"
                :placeholder="$t('Name')"
              />
              <b-form-invalid-feedback v-if="errors && ('name' in errors)"
                                       :state="errors && ('name' in errors) ? false : null">
                {{ errors.name[0] }}
              </b-form-invalid-feedback>

            </b-form-group>



          <!-- contract -->
          <b-form-group :label="$t('Contract')" label-for="contract">
            <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="contractsOptions"
                v-model="groupData.contract_id"
                :placeholder="$t('Contract')"
                :clearable="true"
                :getOptionLabel="val => val.name"
                class="w-100"
                :reduce="val => val.id"
            />

            <b-form-invalid-feedback v-if="errors && ('contract_id' in errors)"
                                     :state="errors && ('contract_id' in errors) ? false : null">
              {{ errors.contract_id[0] }}
            </b-form-invalid-feedback>
          </b-form-group>



          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit">
              {{ $t('Save')}}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="resetData">
              {{ $t('Reset') }}
            </b-button>
          </div>
        </b-form>

    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
  BFormTextarea
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import useGroupEdit from '@/views/modules/group/groups-edit/useGroupEdit'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    OrbitSpinner,

    flatPickr,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewGroupSidebarActive',
    event: 'update:is-add-new-group-sidebar-active',
  },
  props: {
    isAddNewGroupSidebarActive: {
      type: Boolean,
      required: true,
    },
    contractsOptions: {
      type: Array,
      required: true
    }

  },
  setup(props, { emit, root }) {

    const blankData = {
      name: '',
      contract_id: '',
    }


    const errors = ref(null)

    const requestStatus = ref(false)

    // const { toaster } = useGroupEdit(root)

    const groupData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetData = () => {
      groupData.value = JSON.parse(JSON.stringify(blankData))
    }

    const onSubmit = () => {

      requestStatus.value = true
      errors.value = null

      store.dispatch('groups/createGroup', groupData.value)
        .then(() => {
          requestStatus.value = false
          emit('refetch-data')
          emit('update:is-add-new-group-sidebar-active', false)
        }).catch(res => {
          requestStatus.value = false
          if (res.response.status === 422) {
            errors.value = res.response.data.errors
          }
        })
    }


    return {
      groupData,
      onSubmit,
      resetData,
      requestStatus,
      errors
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
